import { useCallback, useEffect, useRef, useState } from 'react';
import { getBatchTokens } from '@/services/tap.service.js';

// Loads the per-token rows for one batch (each tagged with derived status +
// tag URL). refresh() re-pulls after a program / hand-off / revoke mutation.
export default function useTapBatch(label, { agent } = {}) {
  const [tokens, setTokens] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const aborted = useRef(false);

  const refresh = useCallback(async () => {
    if (!label) return;
    try {
      const d = await getBatchTokens(label, { agent });
      if (!aborted.current) {
        setTokens(d?.tokens || []);
        setError(null);
      }
    } catch (err) {
      if (!aborted.current) setError(err);
    } finally {
      if (!aborted.current) setLoading(false);
    }
  }, [label, agent]);

  useEffect(() => {
    aborted.current = false;
    setLoading(true);
    refresh();
    return () => { aborted.current = true; };
  }, [refresh]);

  return { tokens, error, loading, refresh };
}
